import {configureStore} from "@reduxjs/toolkit";
import {authReducer} from "../modules/auth/models/AuthSlice";
import {snackbarReducer} from "../modules/base/models/SnackbarSlice";
import {dashboardReducer} from "../modules/dashboard/models/dashboard-slice";
import {baseReducer} from "../modules/base/models/BaseSlice";
import {copareReducer} from "../modules/dashboard/models/compare-slice";
import {projectInfoReducer} from "./features/ProjectInfoSlice";
import {ToolkitStore} from "@reduxjs/toolkit/dist/configureStore";


export const store : ToolkitStore = configureStore({
    reducer: {
        base: baseReducer,
        auth: authReducer,
        snackbar: snackbarReducer,
        dashboard: dashboardReducer,
        compare: copareReducer,
        projectInfo: projectInfoReducer
    }
});

export type RootState = ReturnType<typeof store.getState>;
